import { Colors, Services } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import { components, labelModes } from '@/utils'

import buttonConfirm from '@/components/button/confirm'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'
import selectorSendername from '@/components/selector/sendername'

function renderHeaderContent(h, options) {
  const { path, serviceName } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: 'sms',
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderField(h, options, field) {
  const { path, serviceName } = options
  const key = `${path}.${field}`
  const commonProps = {
    value: this.proxy[field],
    label: this.getTranslate(`${serviceName}.labels.${key}`),
    labelMode: labelModes.line,
    dense: true,
    clearable: true
  }
  const on = {
    input: event => {
      this.proxy[field] = event
    }
  }

  if (field === 'sendername') {
    return h(
      selectorSendername,
      {
        props: {
          ...commonProps,
          type: SendingTypes.sms,
          required: false
        },
        on
      }
    )
  }

  return h(
    components.select,
    {
      props: {
        ...commonProps,
        service: Services.users,
        query: { isActive: true },
        itemTitle: 'username',
        autocomplete: true,
        details: false
      },
      on
    }
  )
}
function renderItem(h, options, field) {
  const { path, defaults } = options
  const key = `${path}.${field}`

  return h(
    buttonConfirm,
    {
      props: {
        value: this.proxy[field],
        loading: this.getLoading(field),
        disabled: this.getDisabled(field)
      },
      on: {
        input: () => {
          const value = this.proxy[field] ?? defaults[key]

          this.submitField(field, value)
          this.$emit('input', value, key)
        }
      }
    },
    [ renderField.call(this, h, options, field) ]
  )
}
function renderItems(h, options) {
  return this.fields.map(field => {
    return renderItem.call(this, h, options, field)
  })
}

function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--12 pa-2'
    },
    [ renderItems.call(this, h, options) ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderBody.call(this, h, options)
        }
      }
    }
  )
}
